
import { breakpointWidth, breakpointWidthMD } from './_variables';

//
// Set up collapse panesl
//

// the footer makes use of Bootstrap collapse panels
// we want these to only work on smaller viewports
// elements can be hidden with css, but we need to disable the click event handler on the collapse/expand element

window.disableCollapse = function(el, width) {

	el.addEventListener('click', function (e) {

		var windowWidth = window.innerWidth;
		
		if (windowWidth >= width) {
			e.preventDefault();
			e.stopPropagation();
		}
	})
}

window.SetUpCollapsePanels = function() {

	// Footer Link Groups...
	var footerGroups = document.getElementsByClassName('footer-link-group__group-heading-wrapper');

	for (var i = 0; i < footerGroups.length; i++) {

		var group = footerGroups[i];
		
		disableCollapse(group, breakpointWidth);
	}

	// News Filters Panel...
	var newsFilters = document.getElementsByClassName('news-filters__panel-toggle');

	for (var i = 0; i < newsFilters.length; i++) {

		var newsFilter = newsFilters[i];

		disableCollapse(newsFilter, breakpointWidthMD);
	}
}

if (document.readyState !== 'loading') {
	window.SetUpCollapsePanels();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetUpCollapsePanels();
	});
}